import { rxStore } from '@util/rx-store';
import feather from 'feather-icons';
import { persisted } from 'svelte-local-storage-store';
import { signInAnonymously } from 'firebase/auth';
import { derived, get, writable } from 'svelte/store';
import { defaults, auth, pages, firebaseInstance } from './config';

export const defaultUx = { firstTime: true };
export const defaultComponents = {
  formBuilder: {
    inputs: [
      {
        name: '',
        type: 'text',
        attrs: [{ name: '', value: '' }],
      },
    ],
  },
};

export const user = persisted('user', null);
export const ux = persisted('ux', defaultUx);

export const displayName = derived(user, ($user) => {
  const users = ($user?.providerData || []);
  const [acc] = users.filter(d => d?.displayName);

  return acc?.displayName || acc?.email;
}, defaults.guestAccountLabel);

export const app = writable({
  titleBase: 'Webforma Alpha',
});

export const account = persisted('userAccount', null);
export const accounts = persisted('accounts', []);
export const firebaseApp = writable(firebaseInstance);
export const firebaseAuth = writable(auth);
export const components = writable(defaultComponents);

// account not really used but must exist before querying forms
export const forms = persisted('forms', () => {
  const $account = get(account);
  return {
    aid: $account?._id,
    ikey: null,
    data: [],
  };
});

/**
 * pending store allow for decentralized chaining to a promise outcome
 * model: {
 *  {collection}.{id}: promise/undefined
 * }
 */
export const pending = writable({});

export const sites = persisted('sites', {
  ikey: null,
  data: [],
});

export const accountForms = rxStore(null);
export const accountSites = rxStore(null);
export const accountFormMap = rxStore({});
export const accountSiteMap = rxStore({});

export const siteLookup = persisted('siteLookup', {});
export const siteMap = persisted('siteMap', {});

export const emailVerificationChannel = writable(new Map());

// export const account = persisted('account', null);
// export const firebaseApp = persisted('firebaseApp', firebaseInstance);
// export const firebaseAuth = persisted('firebaseAuth', auth);
// export const components = persisted('components', defaultComponents);

async function initUser(u) {
  const uxStore = get(ux);
  if (!u && uxStore?.firstTime) {
    if (window.location.pathname !== pages.entry.welcome.url) {
      window.location = pages.entry.welcome.url;
    }
  }
  if (!u && uxStore.firstTime === false && window.location.pathname === pages.dashboard.url) {
    console.log('create an anon user now');
    const anon = await signInAnonymously(auth);
    user.set(anon.user);
  }
  if (!u && !uxStore.firstTime && window.location.pathname === pages.entry.url) {
    console.log('returning unknown user');
  }
  if (u && !u.email) {
    console.log('anonymous user');
  }
  if (u && u.email) {
    console.log('authenticated user');
  }
}

user.subscribe(async (userStore) => {
  await initUser(userStore);
});

// account.subscribe(async (acc) => {
//   const uid = get(user)?.uid;
//   if (acc === null && uid) {
//     const res = await axios.post(api.account.getAccount.url, { aid: uid, uid });
//     const found = res.data?.result;

//     if (found) {
//       account.set(found);

//       // const aid = found?._id;
//       // const data = await getForms(aid);
//       // const ikey = uuid.v4();
//     }
//   } else {
//     console.warn('No account and no UID');
//   }

//   // if (acc.balance === undefined) {
//   //   const headers = { 'x-webforma-aid': acc.id };
//   //   console.log(headers, acc);
//   //   const res = await axios.get(api.account.getBalance.url);
//   //   acc.balance = res.data;
//   // }
// });

// forms.subscribe(async ({ aid, ikey, data }) => {
//   const $account = get(account);

//   if (!$account) return;

//   console.log('Started', { aid, ikey, data, $account });
//   if (ikey) {
//     console.info('forms - do nothing since ikey is set', ikey);
//     return;
//   }

//   ikey = uuid.v4();
//   const formData = await getForms(aid);
//   console.info('forms -', ikey, formData);

//   forms.update({
//     ikey,
//     aid,
//     data: formData,
//   });

//   console.info('forms -', 'new data set in cache');
// });

ux.subscribe((uxStore) => {
  feather.replace();
  if (uxStore.mode) {
    document.querySelector('html').setAttribute('data-theme', uxStore.mode);
  } else {
    const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');
    const mode = darkThemeMq.matches ? 'dark' : 'light';
    ux.update((uxs) => ({ ...uxs, mode }));
  }
});

// Build the site lookup from forms
accountForms.subscribe(af => {
  console.log('store.accountForms');
  const siteList = get(accountSites);
  (af || []).forEach(form => {
    if (siteList?.length) {
      const formSite = siteList.find(({ _id: id }) => (id === form?.sid));
      siteLookup.update(sl => ({ ...sl, [form?.sid]: formSite }));
    }
  });
});

accountSites.subscribe(siteList => {
  console.log('store.accountSites');
  (siteList || []).forEach(site => {
    siteLookup.update(sl => ({ ...sl, [site._id]: site }));
  });
});
